var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAccountLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7445 22.0596C20.7445 18.1896 16.8945 15.0596 12.1545 15.0596C7.41445 15.0596 3.56445 18.1896 3.56445 22.0596M12.1545 12.0596C13.4805 12.0596 14.7523 11.5328 15.69 10.5951C16.6277 9.65742 17.1545 8.38565 17.1545 7.05957C17.1545 5.73349 16.6277 4.46172 15.69 3.52404C14.7523 2.58635 13.4805 2.05957 12.1545 2.05957C10.8284 2.05957 9.5566 2.58635 8.61892 3.52404C7.68124 4.46172 7.15445 5.73349 7.15445 7.05957C7.15445 8.38565 7.68124 9.65742 8.61892 10.5951C9.5566 11.5328 10.8284 12.0596 12.1545 12.0596Z",
    stroke: "#F2FBFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccountLight);
export default __webpack_public_path__ + "static/media/ic_account_light.328589b411690b99b3b61ffa0bba0e86.svg";
export { ForwardRef as ReactComponent };